import Medal from "assets/icons/Medal.svg"
import { useTranslation } from "react-i18next"
import { BigItem } from "../components"

type LinkLeaderboardsProps = { onClick: () => void }
export const LinkLeaderboards = ({ onClick }: LinkLeaderboardsProps) => {
  const { t } = useTranslation()

  return (
    <BigItem
      title={t("navigation.LEADERBOARDS")}
      icon={Medal}
      onClick={onClick}
      to="/leaderboards"
    />
  )
}
